import { render, staticRenderFns } from "./FormaDePamentoGatewayForm.vue?vue&type=template&id=0af9a4ce&scoped=true&"
import script from "./FormaDePamentoGatewayForm.vue?vue&type=script&lang=js&"
export * from "./FormaDePamentoGatewayForm.vue?vue&type=script&lang=js&"
import style0 from "./FormaDePamentoGatewayForm.vue?vue&type=style&index=0&id=0af9a4ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af9a4ce",
  null
  
)

export default component.exports